import {ChangeDetectionStrategy, Component, OnChanges, input, output} from '@angular/core';
import {PageData} from './models/page-data.model';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent implements OnChanges {
    public readonly currentPage = input<number>(1);
    public readonly pageData = input<PageData>();
    public readonly goToPage = output<number>();

    public currentPageValue: number = 1;

  public firstItem: number = 0;
  public lastItem: number = 0;

  ngOnChanges(): void {
    this.currentPageValue = this.currentPage();
    this.updatePageIndexes();
  }

  resetIndex(): void {
    this.currentPageValue = 1;
    this.updatePageIndexes();
  }

  goToFirstPage(): void {
    if (this.currentPageValue > 1) {
      this.currentPageValue = 1;
      this.updatePageIndexes();
      this.goToPage.emit(this.currentPageValue);
    }
  }

  goToPreviousPage(): void {
    if (this.currentPageValue > 1) {
      this.currentPageValue--;
      this.updatePageIndexes();
      this.goToPage.emit(this.currentPageValue);
    }
  }

  goToNextPage(): void {
    const data = this.pageData();
    if (data && this.currentPageValue < data.totalPages) {
      this.currentPageValue++;
      this.updatePageIndexes();
      this.goToPage.emit(this.currentPageValue);
    }
  }

  goToLastPage(): void {
    const data = this.pageData();
    if (data && this.currentPageValue < data.totalPages) {
      this.currentPageValue = data.totalPages;
      this.updatePageIndexes();
      this.goToPage.emit(this.currentPageValue);
    }
  }

  updatePageIndexes(): void {
    const data = this.pageData();
    if (!data) {
      this.firstItem = 0;
      this.lastItem = 0;
      return;
    }
    if (data.totalElements === 0) {
      this.firstItem = 0;
      this.lastItem = 0;
    } else if (data.totalElements <= data.pageSize) {
      this.firstItem = 1;
      this.lastItem = data.totalElements;
    } else if (this.currentPageValue === 1) {
      this.firstItem = 1;
      this.lastItem = data.pageSize;
    } else if (this.currentPageValue === data.totalPages) {
      this.firstItem = ((this.currentPageValue - 1) * data.pageSize) + 1;
      this.lastItem = data.totalElements;
    } else {
      this.firstItem = ((this.currentPageValue - 1) * data.pageSize) + 1;
      this.lastItem = this.currentPageValue * data.pageSize;
    }
  }
}
